import React from "react";
import "../assets/styles/_base.scss";

export default function Loader(props) {
    if (!props.loading) return null;

    return (
        <div className="sweet-loading">
            <div className="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
}
